<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>

    <div class="mt-2" v-else>
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert_all_page" v-if="alert_success === true">{{ alert_message_success
        }}</v-alert>
        <v-alert type="error" class="alert_all_page" v-if="alert_error === true">{{ alert_message_error }}</v-alert>
      </v-slide-x-reverse-transition>
      <v-row>
        <v-col xs="12" sm="12" md="8" lg="10" xl="10" cols="12">
          <div class="title_page ma-3 mb-0">
            <h4 class="breadcrumb_title_page">รายการสมาชิก</h4>
            <v-breadcrumbs :items="sub_menu">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
            </v-breadcrumbs>
          </div>
        </v-col>
        <v-col xs="12" sm="12" md="4" lg="2" xl="2" cols="12">
          <div class="title_page ma-3 mb-0">
            <v-btn type="button" class="btn_add_data" elevation="2" @click="link('/arin/pos/addcustomerpoint')"
              large>เพิ่มสมาชิก</v-btn>
          </div>
        </v-col>
      </v-row>

      <v-row class="mt-0">
        <v-col>
          <v-card elevation="3" class="pa-4" style="border-radius: 15px">
            <section class="d-flex justify-space-between">
              <div class="mt-1">
                <v-btn color="#4CAF50" class="input-radius" elevation="3" style="color: white;" large
                  @click="exportToExcel()">
                  <v-icon left>mdi-microsoft-excel</v-icon>
                  Excel
                </v-btn>
              </div>
              <div class="mt-1">
                <v-text-field color="#D6BFAF" class="input-radius" append-icon="mdi-magnify" hide-details="auto"
                  required v-model="search" placeholder="ค้นหา..." outlined dense></v-text-field>
              </div>
            </section>
            <section class="mt-3">
              <v-data-table :headers="headers" :items="memberList" :search="search" :footer-props="footer_Props"
                mobile-breakpoint="0">
                <template v-slot:item="dataDetail">
                  <tr>
                    <td class="pa-3">
                      <div>{{ dataDetail.item.member_code }}</div>
                    </td>
                    <td>
                      <div>
                        {{
                          dataDetail.item.branch_number
                            ? dataDetail.item.branch_number
                            : "-"
                        }}
                      </div>
                    </td>
                    <td>
                      <div>{{ dataDetail.item.member_name }}</div>
                    </td>
                    <td class="text-center">
                      <div>
                        {{
                          dataDetail.item.tax_number
                            ? dataDetail.item.tax_number
                            : "-"
                        }}
                      </div>
                    </td>
                    <td>
                      <div>{{ dataDetail.item.tel_number }}</div>
                    </td>
                    <td>
                      <div class="text-center">{{ dataDetail.item.point }}</div>
                    </td>
                    <td>
                      <div class="text-center">
                        {{ dataDetail.item.point_use }}
                      </div>
                    </td>
                    <td>
                      <div class="d-flex justify-center">
                        <v-switch color="#8cc63e" v-model="dataDetail.item.status" @click="
                          changeStatus(
                            dataDetail.item.id,
                            dataDetail.item.status
                          )
                          " inset></v-switch>
                      </div>
                    </td>
                    <td>
                      <div class="pa-2">
                        <v-btn elevation="4" class="ma-1" @click="
                          link(
                            '/arin/pos/detailcustomerpoint/' +
                            dataDetail.item.id
                          )
                          " outlined color="#8EBBDC" style="border-radius: 10px; background-color: #ffffff"
                          title="รายละเอียด">
                          <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        <v-btn elevation="4" class="ma-1" @click="
                          link(
                            '/arin/pos/editcustomerpoint/' +
                            dataDetail.item.id
                          )
                          " outlined color="#FEA06C" style="border-radius: 10px; background-color: #ffffff"
                          title="แก้ไขรายละเอียด">
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn elevation="4" class="ma-1" outlined color="#F28080"
                          @click="delete_member(dataDetail.item.id)"
                          style="border-radius: 10px; background-color: #ffffff" title="ลบข้อมูล">
                          <v-icon>mdi-trash-can-outline</v-icon>
                        </v-btn>
                      </div>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </section>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import img_holder from "@/assets/arin_assets/image_sun_color.png";
import { HTTP_ARIN } from "@/axios_arin";
import cancel_order from "@/assets/arin_assets/cancel_order.png";
import Swal from "sweetalert2";
import * as XLSX from 'xlsx';
export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "Pos_product_list",
  data() {
    return {
      loading_page: false,
      alert_success: false,
      alert_error: false,
      alert_message_success: "",
      alert_message_error: "",
      img_cancel_order: cancel_order,
      search: "",
      page: 1,
      img_holder: img_holder,
      product_type_list: [{ id: 1, name: "ทั้งหมด" }],
      product_type: "",
      promotion_list: [{ id: 1, name: "โปรโมชั่น" }],
      promotion_type: "",
      footer_Props: {
        "items-per-page-text": "รายการต่อหน้า",
      },
      headers: [
        {
          text: "หมายเลขสมาชิก",
          value: "member_code",
          fixed: true,
          //   width: '120px',
          sortable: false,
          align: "left",
        },
        {
          text: "เลขสาขา",
          value: "branch_number",
          fixed: true,
          // width: '160px',
          align: "center",
        },
        {
          text: "ชื่อสมาชิก",
          value: "member_name",
          fixed: true,
          //   width: '300px',
          align: "left",
        },
        {
          text: "เลขที่เสียภาษี",
          value: "tax_number",
          fixed: true,
          // width: '160px',
          align: "center",
        },
        {
          text: "เบอร์โทร",
          value: "tel_number",
          fixed: true,
          //   width: '120px',
          align: "left",
        },
        {
          text: "แต้มที่เหลือ",
          value: "",
          fixed: true,
          //width: '160px',
          align: "center",
        },
        {
          text: "แต้มที่ใช้ไปแล้ว",
          value: "",
          fixed: true,
          //width: '60px',
          sortable: false,
          align: "center",
        },
        {
          text: "สถานะ",
          value: "",
          fixed: true,
          //width: '300px',
          sortable: false,
          align: "center",
        },
        {
          text: "จัดการ",
          value: "",
          fixed: true,
          //   width: '300px',
          sortable: false,
          align: "left",
        },
      ],
      memberList: [],
      dialog_customer_poing_delete: false,
      deleteID: null,
      sub_menu: [
        {
          text: "ระบบ POS",
          disabled: false,
        },
        {
          text: "การสะสมแต้มลูกค้า",
          disabled: false,
        },
        {
          text: "รายการสมาชิก",
          disabled: false,
          href: "#",
        },
      ],
    };
  },
  methods: {
    link(link) {
      window.location.href = link;
    },
    getCustomer() {
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      HTTP_ARIN.get("/member/get/all", config).then((response) => {
        if (response.data.successful === true) {
          this.memberList = response.data.memberList;
          this.memberList = this.memberList.map((item) => {
            return {
              ...item,
              status: item.status == 0 ? 1 : 0,
            };
          });
        }
      });
    },
    exportToExcel() {
  const config = {
    headers: {
      Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
    },
  };
  
  HTTP_ARIN.get("/member/get/all", config).then((response) => {
    if (response.data.successful === true) {
      // เตรียมข้อมูลสำหรับ Excel
      const data = response.data.memberList.map((item, index) => ({
        'ลำดับ': index + 1,
        'หมายเลขสมาชิก': item.member_code,
        'เลขสาขา': item.branch_number || '-',
        'ชื่อสมาชิก': item.member_name,
        'เลขที่เสียภาษี': item.tax_number || '-',
        'เบอร์โทร': item.tel_number,
        'แต้มที่เหลือ': item.point,
        'แต้มที่ใช้ไปแล้ว': item.point_use,
        'สถานะ': item.status == 0 ? 'เปิดใช้งาน' : 'ปิดใช้งาน'
      }));
      
      // สร้าง Excel workbook
      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Member List");
      
      // Export file
      const filename = `member_list_${new Date().toISOString().slice(0, 10)}.xlsx`;
      XLSX.writeFile(wb, filename);
    }
  }).catch((error) => {
    console.error('Error exporting Excel:', error);
    this.alert_message_error = "เกิดข้อผิดพลาดในการ export ข้อมูล";
    this.alert_error = true;
    setTimeout(() => (this.alert_error = false), 5000);
  });
},
    changeStatus(id, checked) {
      let status = 0;
      if (checked === true) {
        status = 0;
      } else {
        status = 1;
      }
      const data = {
        status: status,
      };
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      HTTP_ARIN.post("/member/change/status/" + id, data, config)
        .then((response) => {
          if (response.data.successful === true) {
            this.alert_message_success = "เปลี่ยนสถานะเรียบร้อยแล้ว";
            this.alert_success = true;
            setTimeout(() => (this.alert_success = false), 5000);
          }
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.$store.commit("logOutSuccess");
            this.$router.push("/login");
          }
        });
    },
    delete_member(id) {
      Swal.fire({
        title: "คุณแน่ใจไหม?",
        text: "หากลบข้อมูลแล้วคุณจะกู้ข้อมูลกลับไม่ได้!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ใช่, ลบข้อมูล",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.isConfirmed) {
          const config = {
            headers: {
              Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
            },
          };
          HTTP_ARIN.get("/member/delete/" + id, config).then((response) => {
            if (response.data.successful === true) {
              let timerInterval;
              Swal.fire({
                title: "เสร็จสิ้น",
                text: "ลบข้อมูลเรียบร้อยแล้ว",
                icon: "success",
                timer: 2000,
                timerProgressBar: true,
                didOpen: () => {
                  Swal.showLoading();
                  timerInterval = setInterval(() => { });
                },
                willClose: () => {
                  clearInterval(timerInterval);
                  setTimeout(function () {
                    window.location.reload();
                  });
                },
              });
            } else {
              Swal.fire({
                title: "แจ้งเตือน",
                text: "ไม่สามารถดำเนินการได้ กรุณาลองใหม่อีกครั้ง!",
                icon: "error",
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: `ตกลง`,
                denyButtonText: `ยกเลิก`,
              });
            }
          });
        }
      });
    },
  },
  mounted() {
    this.getCustomer();
  },
  watch: {
    page() {
      this.getCustomer();
    },
  },
};
</script>

<style scoped>
.grid_three {
  display: grid;
  grid-template-columns: 33.33% 33.33% 33.34%;
}

.input-radius {
  border-radius: 10px;
}

.preview {
  border-radius: 10px;
  margin: auto;
}

.width>>>input {
  max-width: 100%;
  text-align: center;
}

.v-btn:not(.v-btn--round).v-size--default {
  height: 35px;
  min-width: 50px;
  padding: 0 5px;
}
</style>
